import React, { useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddToHomeScreen = ({ message, isError }) => {
	const notify = useCallback(
		() =>
			toast(<span class="addToHomeBanner">{message} </span>, {
				position: 'bottom-center',
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			}),
		[message],
	);
	const error = useCallback(
		() =>
			toast.error(<span>{message} </span>, {
				position: 'bottom-center',
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			}),
		[message],
	);

	useEffect(() => {
		if (isError) {
			error();
		} else notify();

		return () => {
			toast.dismiss();
		};
	}, [error, isError, notify]);

	return (
		<div>
			<ToastContainer
				position="bottom-center"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
		</div>
	);
};

export default AddToHomeScreen;
